// extracted by mini-css-extract-plugin
export var csatScore = "_lx-5";
export var header = "_lx-1";
export var panelWrapper = "_lx-2";
export var postPreview = "_lx-3";
export var rightContent = "_lx-0";
export var wrappingText = "_lx-4";